// @ts-nocheck
import React from "react";
import useSelect from "hooks/useSelect";
import genRequest from "includes/request";
import {useQueryClient} from "react-query";
import { t } from "i18next";
import promiseToast from "components/Toasts/PromiseToast";
import TableToolbar from "components/Table/TableToolbar/TableToolbar";

export default function DocsTableToolbar(props) {
	const {selectedRows, clearSelection} = props;
	const {confirmDelete} = useSelect();
	const QCL = useQueryClient();

	function handleDelete() {
		if (!selectedRows?.length)
			return (false);
		let title = selectedRows?.length + " " + t("Docs.MULTI_RM_MSG");
		if (selectedRows?.length < 2)
			title = `${t("Docs.THE_DOC")} "${selectedRows[0].name}" ${t("Docs.WILL_BE_DELETE")}`;
		confirmDelete(
			() => {
				delSelecteds();
			},
			null,
			title
		);
	}

	function delSelecteds() {
		let proms = selectedRows.map((doc, x) => {
			let prom = false;
			if (doc?.id)
				prom = new Promise((resolve, reject) => {
					setTimeout(() => {
						genRequest(
							`documents/${doc.id}`,
							null,
							"delete"
						).then((resp) => {
							resolve(resp);
						}, reject);
					}, 500 * x);
				})
			return (prom);
		});

		let prom = Promise.allSettled(proms).then(() => {
			QCL.resetQueries(["DocumentsController"]);
			clearSelection();
		});
		promiseToast(
			prom,
			{
				pending: t("Docs.DELETING", {count: selectedRows?.length})
			}
		)
		return (prom);
	}

	return (
		<TableToolbar
			{...props}
			handleDelete={handleDelete}
		/>
	);
}
